import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import EditReturnLossForm from '../EditReturnLossForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function EditReturnLossListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขรายการคืนยอดเสีย`}
					description="แก้ไขรายการคืนยอดเสีย"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<EditReturnLossForm />
		</div>
	)
}
